/* global */
// BEGIN VENDOR ASSETS
// Import theme specific vendor assets here, this should be a rare case
// END VENDOR ASSETS

// BEGIN INDIVIDUAL COMPONENT SCRIPTS
// NOTE: If your component does not need specific script functiionality there
// is no need to include the default scripts from the component starter
import '../../components/component-menu/src/scripts/_base.js'
import '../../components/component-feestooltip/src/scripts/_base.js'
import '../../components/component-marketsearch/src/scripts/_base.js'
// END INDIVIDUAL COMPONENT SCRIPTS

(($) => {
  window.COMPONENTSCHILD || (window.COMPONENTSCHILD = {})

  COMPONENTSCHILD.init = () => {
    console.log('HELLO FROM COMPONENTS CHILD THEME')
  }

  $(document).ready(() => {
    COMPONENTSCHILD.init()
  })
}
)(jQuery)
